import { render, staticRenderFns } from "./WorkshopStatus.vue?vue&type=template&id=6c1411d8"
import script from "./WorkshopStatus.vue?vue&type=script&lang=js"
export * from "./WorkshopStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports